import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  { label: 'Pré-pago', value: 'pre_paid' },
  { label: 'Pós-pago', value: 'post_paid' },
]

export const strategy = optionsToStrategy(options);